// extracted by css-extract-rspack-plugin
export default {"Root":"Syg4v"};